import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { axiosInstanceNamek } from "@/service/Axios";

import { ASSIGN_MATERIALS_KEYS } from "../../assignMaterials/services/queryKeys";

import { MATERIALS_KEYS as KEYS } from "./queryKeys";

const doDelete = async (id: number): Promise<void> => {
  return axiosInstanceNamek
    .delete<void, AxiosResponse<void>>(`v1/materials/${id}`)
    .then((response) => response.data);
};

export function useDeleteMaterial() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, number>({
    mutationFn: (id) => doDelete(id),
    mutationKey: [KEYS.DELETE],
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [KEYS.RECORDS],
      });
      await queryClient.invalidateQueries({
        queryKey: [ASSIGN_MATERIALS_KEYS.RECORDS],
        refetchType: "all",
      });
    },
  });
}
